import { makeStyles } from '@mui/styles';
import { COLOR_PINK } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  text: {
    [theme.breakpoints.up('md')]: {
      fontSize: 13,
    },
    fontSize: 10,
    fontWeight: 700,
    color: theme.palette.common.white,
  },
  link: {
    fontSize: 13,
    color: theme.palette.common.white,
    fontWeight: 900,
    textDecorationColor: theme.palette.common.white,
  },

  icon: {
    width: 35,
  },
  banner: {
    backgroundColor: COLOR_PINK,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.75),
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2, 10),
      gap: theme.spacing(4),
      flexDirection: 'row',
    },
  },
}));
